import dayjs, { Dayjs } from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'

import 'dayjs/locale/fr'
dayjs.locale('fr')
dayjs.extend(relativeTime)
dayjs.extend(customParseFormat)
dayjs.extend(weekOfYear)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)
dayjs.extend(duration)

type DateInput = string | number | Date | Dayjs | null | undefined

const datetime = (value: DateInput, placeholder = 'N/A'): string => {
  if (value === undefined || value === null) {
    return placeholder
  }
  return dayjs(value).format('DD/MM/YYYY à HH:mm')
}

const date = (value: DateInput, placeholder = 'N/A'): string => {
  if (value === undefined || value === null) {
    return placeholder
  }
  return dayjs(value).format('DD/MM/YYYY')
}

const dateForInput = (value: DateInput): string => {
  return dayjs(value).format('YYYY-MM-DD')
}

const isToday = (value: DateInput): boolean => {
  return dayjs().isSame(value, 'day')
}

const isNow = (value1: DateInput, value2: DateInput): boolean => {
  return dayjs(value1).isSameOrAfter(value2, 'minute')
}

const isPast = (value: DateInput): boolean => {
  return dayjs().isAfter(value, 'hour')
}

const timeLeft = (value: DateInput, withPrefix = true): string => {
  if (value === undefined || value === null) {
    return 'N/A'
  }
  return dayjs().to(value, !withPrefix)
}

const timeFrom = (value: DateInput, withPrefix = true): string => {
  if (value === undefined || value === null) {
    return 'N/A'
  }
  return dayjs(value).from(dayjs(), !withPrefix)
}

const useDateTime = {
  methods: {
    datetime,
    date,
    dateForInput,
    timeLeft,
    timeFrom,
    isPast,
  },
}

export { useDateTime, dayjs, datetime, date, dateForInput, isToday, timeLeft, isNow }
